export default __webpack_public_path__ + "static/media/coin_icon_big.c28cb914.png";